export class AppraisalReport {
	public idMongo: string
	public date: string
	public demandStatus: 'WITHOUT_DEMAND' | 'WITH_DEMAND' | 'ADDED_DEMAND'
		public qrCodeImage: string
	public oldReport: string
	public appraisalDone: boolean
	public assign: boolean
		public address: Location
	public tree: Tree
	public handleOperations: Array<HandlerOperations>
	public responsible: ReportReponsible
	public editResponsible: EditReponsible
	public responsibleForSign: ResponsibleForSign
	public evaluationResult: EvaluationResult
	public riskAssessment: RiskAssessment
	public answers: Array<Answer>
		public requester: Requester
	public genericsEditable: GenericsEditable
}

export class GenericsEditable {
	public considerations: string
	public process: string
	public treeIdentifier: string
}

export class ResponsibleForSign {
	public name: string = ''
	public crea: string = ''
}

export class Requester {
	public name: string
	public cpf: string
	public telephone: string
	public email: string
	public cnpj: string
	public socialName: string
	public notEditable: boolean
}

export class Answer {
	public url: string
	public question: string
	public answer: Array<string>
	public other: {
		question: string,
		answer: string
	}
}

export class ReportReponsible {
		public idMongo: string = ''
		public name: string = ''
		public crea: string = ''
		public email: string = ''
}

export class EditReponsible {
		public name: string = ''
		public editDate: string = ''
}

export class Location {
		public street: string = ''
		public lat: number = 0
		public lng: number = 0
		public locationCategory: string = ''
		public comments: string = ''
	public notFoundDetails: NotFoundDetails
}

export class Tree {
		public idMongo: string
		public identification: number
		public specie: string
		public popularName: string
		public family: string
		public source: string
		public specialCategory: string
		public specieId: string
		public totalHeight: string
		public dapCap: string
		public dapCapType: string
		public stemHeight: string
		public woodVolume: string
		public cupProjection: string
		public specialValue: string
		public treeFormat: {
				url: string,
				status: string
		}
		public mediaTree: string
		public status: string
		public notFound: boolean
		public treeState: 'ALIVE' | 'DEAD'
}

export class NotFoundDetails {
	public reason: 'ADDRESS_INVALID' | 'TREE_REMOVED' | 'RESIDENT_NOT_HOME' | 'OTHER'
	public textJustify: string
	public media: Array<string>
}

export class HandlerOperations {
	public idMongo: string
	public operation: string
	public status?: string
	public legalFundamentation?: string
	public sections?: Array<Section>
}

export class Section {
	public id?: number
	public name: string
	public description: string
}

export class EvaluationResult {
	public degreeOfRisk: 'NENHUM' | 'BAIXO' | 'MODERADA' | 'ALTO' | 'MUITO_ALTO'
	public nextEvaluation: 'NENHUM' | 'INTENSIVO' | 'CORRETIVO' | 'PREDITIVO' | 'PREVENTIVO'
	public residualRisk: 'NENHUM' | 'INSIGNIFICANTE' | 'ACEITAVEL' | 'TOLERAVEL' | 'CONSIDERAVEL'
	public fallProbability: 'IMPROVAVEL' | 'POSSIVEL' | 'PROVAVEL' | 'IMINENTE'
	public impactProbability: 'MUITO_BAIXO' | 'BAIXO' | 'MEDIO' | 'ALTO'
	public fallConsequence: 'INSIGNIFICANTE' | 'REDUZIDA' | 'SIGNIFICATIVA' | 'GRAVE'
}

export class RiskAssessment {
	public av1: Assessment = new Assessment()
	public av2: Assessment = new Assessment()
	public av3: Assessment = new Assessment()
}

export class Assessment {
	public title: string = ''
	public status: 'released' | 'no-released' | 'required' | 'requested' = 'no-released'
}
